<template>
    <DialogTitle
        as="h3"
        class="text-lg leading-6 font-medium text-primary"
    >
        <slot />
    </DialogTitle>
</template>

<script setup lang="ts">
import { DialogTitle } from '@headlessui/vue';
</script>
